import React, { useEffect, useRef, useState } from 'react';
import { LoadingOutlined } from "@ant-design/icons";

export const AwsWafCaptcha = ({ 
  apiKey, 
  integrationUrl, 
  onSuccess, 
  onError,
  className = "",
  ...otherConfig 
}) => {
  const containerRef = useRef(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `${integrationUrl}/jsapi.js`;
    script.defer = true;
    script.onload = () => setIsScriptLoaded(true);
    script.onerror = () => setError('Failed to load CAPTCHA script');
    
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [integrationUrl]);

  useEffect(() => {
    if (isScriptLoaded && containerRef.current && window.AwsWafCaptcha) {
      try {
        window.AwsWafCaptcha.renderCaptcha(containerRef.current, {
          apiKey: apiKey,
          onSuccess: (wafToken) => {
            console.log('CAPTCHA completed successfully');
            if (onSuccess) {
              onSuccess(wafToken);
            }
          },
          onError: (error) => {
            console.error('CAPTCHA error:', error);
            setError(error);
            if (onError) {
              onError(error);
            }
          },
          ...otherConfig
        });
      } catch (err) {
        console.error('Error rendering CAPTCHA:', err);
        setError(err.message);
      }
    }
  }, [isScriptLoaded, apiKey, onSuccess, onError, otherConfig]);

  if (error) {
    return (
      <div className={`captcha-error ${className}`}>
        <p>Error loading CAPTCHA: {error}</p>
        <button onClick={() => window.location.reload()}>
          Reload Page
        </button>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef} 
      className={`captcha-container ${className}`}
    >
      {!isScriptLoaded && (
        <div className="captcha-loading h-100 w-100">
          <div className="d-flex justify-content-center antd-loading-icon hs-min-h-32-vh hs-fs-32">
          <LoadingOutlined spin className="" />
        </div>
        </div>
      )}
    </div>
  );
};
